import { render, staticRenderFns } from "./Landing2Solution.vue?vue&type=template&id=40caa722&"
import script from "./Landing2Solution.vue?vue&type=script&lang=js&"
export * from "./Landing2Solution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports